<template>
  <div>
    <navBar />
    <div class="container main-container">
      <div class="bg-container">
        <img src="@/assets/images/recruit/banner.png">
        <p>英檬招聘</p>
      </div>
      <h1>招聘职位</h1>
      <span class="line"></span>
      <div class="box">
        <el-tabs v-model="activeName">
          <el-tab-pane label="技术" name="first">
            <div class="recruit-container" style="padding-top: 0">
              <div class="title-container">
                <h2>运维工程师</h2>
                <el-button type="primary" @click="submit">我要应聘</el-button>
              </div>
              <div class="tags-container">
                <el-tag type="info" >3年以上工作经验</el-tag>
                <el-tag type="info" >大专及以上</el-tag>
              </div>
              <div class="require-container">
                <p>任职要求：</p>
                <p>1、3年以上运维相关工作经验，大专及以上学历；</p>
                <p>2、熟悉主流开源软件如Nginx, Redis, Docker, MySQL, Elastic Search, Kafka, K8s/Docker等的安装、配置、优化；</p>
                <p>3、熟悉阿里云、AWS至少一种云环境的配置、监控等，熟悉DevOps工具；</p>
                <p>4、能编写并使用脚本进行自动化系统维护, 熟悉Shell、Python编程以及SQL查询。</p>
                <p class="padding-top-20">岗位职责：</p>
                <p>1、开发和测试环境安装、部署和维护工作，包括操作系统、数据库、容器和虚拟化环境、DevOps相关工具等；</p>
                <p>2、解决运维工作中的一般性故障，性能瓶颈等相关问题，提升系统性能和稳定性，保障各环境的稳定运行；</p>
                <p>3、整理编写运维手册、运维月报，按要求提供SQL临时报表；</p>
                <p>4、配置、编写自动化运维脚本，学习新技术，提高运维工作效率。</p>
              </div>
            </div>
            <div class="recruit-container">
              <div class="title-container">
                <h2>中/高级 前端开发工程师</h2>
                <el-button type="primary" @click="submit">我要应聘</el-button>
              </div>
              <div class="tags-container">
                <el-tag type="info" >2-5年以上工作经验</el-tag>
                <el-tag type="info" >web开发经验</el-tag>
              </div>
              <div class="require-container">
                <p>任职要求：</p>
                <p>1、中级：2-4年、高级5年以上，Web前端开发经验并熟练使用html/CSS/Javascript；</p>
                <p>2、具有实际使用过AngularJs，VUE，React等至少一种前端JS框架的项目经验，熟练使用ES6语法；</p>
                <p>3、熟练使用Webpack、Gulp、Browserify、Grunt等任何一种构建工具；</p>
                <p>4、具有解决不同前端浏览器兼容性问题的经验者优先。</p>
                <p class="padding-top-20">岗位职责：</p>
                <p>1、负责公司产品或项目Web前端研发，并配合后端的开发；</p>
                <p>2、根据需求实现页面交互效果；</p>
                <p>3、参与或负责系统前端设计和核心代码的编写；</p>
                <p>4、实现设计需求，提升产品用户体验。</p>
              </div>
            </div>
            <div class="recruit-container">
              <div class="title-container">
                <h2>中/高级 Java开发工程师</h2>
                <el-button type="primary" @click="submit">我要应聘</el-button>
              </div>
              <div class="tags-container">
                <el-tag type="info" >2-5年以上工作经验</el-tag>
                <el-tag type="info" >JAVA开发经验</el-tag>
              </div>
              <div class="require-container">
                <p>任职要求：</p>
                <p>1、中级：2-4年、高级5年以上，JAVA开发经验，有独立完成项目的能力，本科及以上学历；</p>
                <p>2、精通Java，熟悉SpringBoot、Docker，有SpringCloud、K8S等微服务实际项目开发经验；</p>
                <p>3、熟练使用主流数据库(MySQL/MongoDB等)，熟悉分布式、缓存、消息等机制，熟悉Linux命令和操作。</p>
                <p class="padding-top-20">岗位职责：</p>
                <p>1、设计和参与架构设计、开发；</p>
                <p>2、细化需求，编写设计和开发相关文档；</p>
                <p>3、协助管理项目与代码质量。</p>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="产品" name="second">
            <div class="recruit-container" style="padding-top: 0">
              <div class="title-container">
                <h2>产品经理</h2>
                <el-button type="primary" @click="submit">我要应聘</el-button>
              </div>
              <div class="tags-container">
                <el-tag type="info" >3年以上工作经验</el-tag>
                <el-tag type="info" >本科及以上</el-tag>
              </div>
              <div class="require-container">
                <p>任职要求：</p>
                <p>1、本科以上学历，有3年以上产品经理工作经验，有零售、消费品行业CRM系统经验者优先，运营、经历过一个产品的完整生命周期者优先；</p>
                <p>2、有CRM相关的项目/产品管理经验，习惯于用严谨科学的统筹方法来保证工作按计划进行。能独立自主完成整个项目/产品的实施和运作。</p>
                <p>3、熟练掌握产品设计工具(Axure、Visio、墨刀、office等)。</p>
                <p class="padding-top-20">岗位职责：</p>
                <p>1、负责零售/消费品/渠道/营销方面CRM产品设计，负责需求管理(行业需求收集、记录、理解、分析、蓝图等)；</p>
                <p>2、CRM产品规划，业务流程设计，功能设计，产品优化，交互设计等，撰写需求文档工作。提供产品需求文档(PRD)、产品原型设计、需求分
析、功能描述及业务演示原型等文档；</p>
                <p>3、关注用户反馈和体验，就目标群体特点及需求，对产品交互提出建设性意见；</p>
                <p>4、根据产品运营现状和发展目标，制定产品优化策略；</p>
                <p>5、负责产品上线以后的改进:BUG跟踪、收集改进意见、提供改进方案，引导用户熟悉使用产品。</p>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="项目" name="third">
            <div class="recruit-container" style="padding-top: 0">
              <div class="title-container">
                <h2>项目经理</h2>
                <el-button type="primary" @click="submit">我要应聘</el-button>
              </div>
              <div class="tags-container">
                <el-tag type="info" >5年以上工作经验</el-tag>
                <el-tag type="info" >本科及以上</el-tag>
              </div>
              <div class="require-container">
                <p>任职要求：</p>
                <p>1、本科以上学历，计算机/计算数学/软件相关专业，有CRM,互联网及零售业项目经验者优先；</p>
                <p>2、5年以上软件项目管理/开发管理经验，有独立带领团队完成项目的经验和能力；</p>
                <p>3、良好的英文读写能力者择优录取。</p>
                <p class="padding-top-20">岗位职责：</p>
                <p>1、负责组织CRM/大数据分析项目的需求、开发、上线、验收等各环节，对项目的目标、人员、计划、进度、质量、风险等各要素进行管理；</p>
                <p>2、项目前期与客户进行沟通，了解客户需求，制定项目解决方案；项目进行中与客户沟通，同步项目状态，维持客户关系；项目后期，组织客
户培训，推进项目验收；</p>
                <p>3、组织项目开发实施，对项目交付质量进行管理，协调解决项目过程中的重点难点问题，处理项目危机，撰写项目交付文档；</p>
                <p>4、总结项目过程问题、产品问题，提出改进意见，优化项目过程和产品。</p>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="运营" name="fourth">
            <div class="recruit-container" style="padding-top: 0">
              <div class="title-container">
                <h2>数据/业务分析师</h2>
                <el-button type="primary" @click="submit">我要应聘</el-button>
              </div>
              <div class="tags-container">
                <el-tag type="info" >2年以上工作经验</el-tag>
                <el-tag type="info" >本科及以上</el-tag>
              </div>
              <div class="require-container">
                <p>任职要求：</p>
                <p>1、全日制本科或以上学历，2年以上数据运营/分析/咨询（定量）工作经验，有社交媒体平台、CRM分析经验优先；</p>
                <p>2、鞋服、美妆、零售、汽车行业数据工作经验优先；</p>
                <p>3、熟练使用各种数据分析工具（如：Excel、Sql、Tableau、PBI等）。</p>
                <p class="padding-top-20">岗位职责：</p>
                <p>1、负责对于全渠道交易数据、业务运营数据、CRM的数据分析，根据业务需求设计规划常规分析报告，设计数据报表并根据工作需求呈现；</p>
                <p>2、负责对于平台、竞品的数据日常归口统计，进行分析和总结，并建立数据监测机制，及时发现异常并预警；</p>
                <p>3、根据业务实际情况，准确提供个数据报表，包括日报、周报、月报等数据报表；</p>
                <p>4、分析数据产生的逻辑，能够针对数据做出有效分析，对数据进行可视化处理，并提出相关业务改进意见。</p>
              </div>
            </div>
            <div class="recruit-container">
              <div class="title-container">
                <h2>客户执行（SAE/AE）</h2>
                <el-button type="primary" @click="submit">我要应聘</el-button>
              </div>
              <div class="tags-container">
                <el-tag type="info" >2年以上工作经验</el-tag>
                <el-tag type="info" >大专及以上</el-tag>
              </div>
              <div class="require-container">
                <p>任职要求：</p>
                <p>1、2年以上零售、快消、母婴、汽车等行业CRM运营经验优先；</p>
                <p>2、具有很强的项目管理及项目执行力，能够高效的跨部门沟通和跨团队协作；</p>
                <p>3、有微信社群运营经验优先。</p>
                <p class="padding-top-20">岗位职责：</p>
                <p>1、负责提高用户活跃度和留存率，分析数据，识别、理解用户需求，提高产品活跃和提高产品的体验和满意度；</p>
                <p>2、会员系统的完善及维护、会员活动策划、内容营销，提高老客互动粘性，增加复购及忠诚度；</p>
                <p>3、有针对性地开展产品推广，增加用户积极性和参与度，并配合产品需要进行推广方案策划。</p>
              </div>
            </div>
            <div class="recruit-container">
              <div class="title-container">
                <h2>客户经理</h2>
                <el-button type="primary" @click="submit">我要应聘</el-button>
              </div>
              <div class="tags-container">
                <el-tag type="info" >3年以上工作经验</el-tag>
                <el-tag type="info" >本科及以上</el-tag>
              </div>
              <div class="require-container">
                <p>任职要求：</p>
                <p>1、3年及以上相关行业客户服务经验，美妆、快消品、母婴、餐饮、汽车、洋酒类项目服务经验优先；</p>
                <p>2、至少2年CRM项目执行经验（CRM活动计划及执行、业务报告、渠道发送、数据管理及供应商管理等）；</p>
                <p>3、英语听说读写熟练者优先考虑。</p>
                <p class="padding-top-20">岗位职责：</p>
                <p>1、协调各方资源，全面管理项目的计划、策划、实施，保证项目的进度和质量控制；</p>
                <p>2、合理制定项目阶段性目标和总体控制计划，明确划分工作内容，确定阶段性目标实现，并可根据各种变化及时调整项目计划；</p>
                <p>3、管理项目策划、计划与执行，掌控项目进程，有效监控与协调项目执行；</p>
                <p>4、负责项目CRM客户运营管理。</p>
              </div>
            </div>
            <div class="recruit-container">
              <div class="title-container">
                <h2>高级客户经理</h2>
                <el-button type="primary" @click="submit">我要应聘</el-button>
              </div>
              <div class="tags-container">
                <el-tag type="info" >5年以上工作经验</el-tag>
                <el-tag type="info" >本科及以上</el-tag>
              </div>
              <div class="require-container">
                <p>任职要求：</p>
                <p>1、本科及以上学历，至少5年以上CRM/Social/Digital/新零售领域工作经验，2年以上同等职位汽车品牌CRM工作管理经验优先考虑；</p>
                <p>2、能独立梳理方案思路及框架，并高效完成各类PPT方案的撰写工作；</p>
                <p>3、具备一定的数据处理&分析能力，热爱学习，对市场趋势及最新的营销技术敏锐；</p>
                <p>4、流利的英语听说读写和表达能力，可将英语作为工作语言。</p>
                <p class="padding-top-20">岗位职责：</p>
                <p>1、与客户沟通，敏锐把握客户的需求，为客户提供专业咨询，和方案解决服务；</p>
                <p>2、深入理解市场、竞争及消费者，根据客户需求，独立策划管理、执行品牌市场活动；</p>
                <p>3、负责与公司各部门之间进行及时的沟通与协调，在规定时间内保质保量完成工作；</p>
                <p>4、协调公司内部资源和第三方资源，供应商管理、制作物料质量把控、流程管理、项目工作进展报告。</p>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <footerBar />

    <!-- 上传 -->
    <div class="download">
      <el-dialog
        title="上传简历信息"
        :visible.sync="dialogVisible"
        width="32%"
        :before-close="handleClose"
        :close-on-click-modal = "false"
        :close-on-press-escape = "false"
      >
       <el-upload
          class="upload"
          ref="upload"
          accept=".doc, .docx, .pdf"
          :before-upload="beforeUpload"
          :file-list="fileList"
          v-show="showName == 1"
          :http-request="upload"
          action="#"
        >
          <el-button  type="default">
            <img src="@/assets/images/recruit/download.png">上传简历
          </el-button>     
        </el-upload>
            <div class="show-info" v-show="showName == 2 " @click.stop>
          {{fileName}} &nbsp;&nbsp;已上传<span class="clear" @click.stop="clearFile">X</span>
        </div>

          <div class="show-info"  v-show="showName == 3 " @click.stop>
           {{fileName}}&nbsp;&nbsp;{{ uploadSuccess ? '已上传' : '' }}<span class="clear" @click.stop="clearFile">X</span>
         </div>

        <el-progress v-if="progressFlag" :percentage="loadProgress" :show-text="false"></el-progress>
 
        <div class="tags">
          注： 文件后缀名必须为doc、docx(即word)或PDF格式，小于5M
          <div class="btn">
            <el-button type="primary"  @click="uploadFile" round  :disabled="disabled">确 定</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import navBar from "@/components/nav-bar";
import footerBar from "@/components/footer-bar";
import config from "@/assets/config.json";
export default {
  data() {
    return {
      activeName: 'first',
      dialogVisible: false,
      fileList: [],
      uplodeFileName:'',
      loadProgress: 0, // 上传进度条
      status: null,
      fileName:'',
      showName:1,
      progressFlag:false,
      // action: "",
      fd: new FormData(),
      uploadSuccess: false,
      disabled: false,
    }
  },
  components: {
    navBar,
    footerBar,
  },
  methods: {
    upload(file) {
      console.log("file", file);
      this.fd.append("file", file.file);
      // this.fileName = file.file.name;
      // this.showName = 3;
    },
    submit() {
      // this.$message.info("暂未开通");
      this.dialogVisible  = true;
      this.showName = 1;
      this.fileList = [];
    },
    handleClose() {
      this.dialogVisible = false;
      this.loadProgress  = 0;
      this.progressFlag = false;
      this.disabled = false;
      this.showName = 1;
      this.uploadSuccess = "";
    },
    handleRemove(file, fileList) {
      // console.log(file, fileList);
    },
    handlePreview(event, file, fileList) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
      // console.log(file);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${ file.name }？`);
    },
    uploadVideoProcess(event, file, fileList) {
      console.log("[uploadVideoProcess] start.");
      this.progressFlag = true; // 显示进度条
      this.loadProgress = parseInt(event.percent); // 动态获取文件上传进度
      if (this.loadProgress >= 100) {
          this.loadProgress = 100
          // setTimeout( () => {this.progressFlag = false}, 2500) // 一秒后关闭进度条
      }
    },

    clearFile(){
      this.disabled = false;
      this.showName = 1;
      this.fileList = [];
      this.progressFlag = false;
      this.loadProgress = 0;
      this.uploadSuccess = "";
    },
      
    uploadFile() {
      if(this.showName == 1) {
        this.$message.warning("请先上传简历");
        return;
      }
      this.disabled = true;
      this.$axios({
        method:'post',
        // url:`https://tst-phd.remycn.com/octomore-sms/octomore/mail/upload`,
        url:`${config.api.api}/indation/common/mail/upload`,
        data: this.fd,
        onUploadProgress: (progressEvent) => {
          this.progressFlag = true; // 显示进度条
          this.loadProgress = parseInt(progressEvent.loaded / progressEvent.total * 100 || 0); // 动态获取文件上传进度
          if (this.loadProgress >= 100) {
            this.loadProgress = 100
          }
        }
      }).then((response) =>{
        if(response.data.code === 200){
          this.$message.success('提交成功');
          this.uploadSuccess = true;
        } else {
          this.$message.error('提交失败');
          this.uploadSuccess = false;
           this.disabled = false;
          return false;
        }
      }).catch((error) => {
        this.$message.error(error); //请求失败返回的数据
        this.uploadSuccess = false;
        this.disabled = false;
      })
    },

    //on-success
    handleAvatarSuccess(res, file) {
      console.log("handleAvatarSuccess", res, file);
      // if(res.code == 200){
      //   this.showName = 2
      //   this.fileName = file.name;
      //   this.$message.success("提交成功");
      // } else {
      //   this.$message.success("提交失败，请重新再试！");
      // }
    },
    // 上传文件前校验
    beforeUpload(file) {
      var testmsg=file.name.substring(file.name.lastIndexOf('.')+1)		
      const extension = testmsg === 'doc'
      const extension2 = testmsg === 'docx'
      const extension3 = testmsg === 'pdf'
      const isLt2M = file.size / 1024 / 1024 < 5  // 这里做文件大小限制
      if(!extension && !extension2 && !extension3) {
        this.$message.warning("上传文件只能是 doc、docx或pdf格式!");
        return;
      }
      if(!isLt2M) {
        this.$message.warning("上传文件大小不能超过 5MB");
        return;
      }
      this.showName = 3;
      this.fileName = file.name;
    },
  }
}
</script>
<style lang="scss" scoped>
.container{
  max-width: 1920px;
  padding-bottom: 127px;
  .bg-container {
    position: relative;
    overflow: hidden;
    max-width: 1920px;
    min-width: 1200px;
    margin: 0 auto;
    p {
      font-size: 40px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      line-height: 68px;
      color: #FFFFFF;
      position: absolute;
      top: 208px;
      left: 645px;
    }
  }
  h1 {
    padding-top: 110px;
    padding-bottom: 25px;
    font-size: 32px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    // line-height: 30px;
    color: #333333;
    text-align: center;
    // letter-spacing: 40px;
  }
  .line {
    display: block;
    width: 60px;
    height: 2px;
    background: #1F71FF;
    margin: 0 auto;
    margin-bottom: 90px;
  }
  .box {
    max-width: 1200px;
    margin: 0 auto;
    .recruit-container {
      border-bottom: 1px solid #C4DAFF;
      padding: 40px 0 30px;
      margin: 0 50px;
      .title-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        h2 {
          font-size: $font-size-20;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #464646;
        }
        /deep/ .el-button--primary {
          font-size: 14px;
          font-family: Source Han Sans CN;
        }
      }
      .tags-container {
        margin: 20px 0;
      }
      .require-container {
        p {
          font-size: $font-size-18;
          font-family: Source Han Sans CN;
          font-weight: 400;
          line-height: 30px;
          color: #7E7E7E;
        }
      }
    }
  }
}

/deep/ .el-tabs__item {
  padding: 0 128px !important;
  font-size: $font-size-22;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #464646;
  line-height: 30px;
}

/deep/ .el-tabs__nav-wrap {
  margin-bottom: 65px;
}

/deep/ .el-tabs__active-bar {
  bottom: 0;
  left: -34px;
  width: 120px !important;
}

/deep/ .el-tabs__item.is-active {
  color: #409EFF !important;
}

/deep/ .el-tag--info {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
}

.download {
  .upload {
    /deep/ .el-button--small, .el-button--small.is-round {
      padding: 9px 20px 9px 35px;
      position: relative;
    }
  }
  img {
    position: relative;
    top: 2px;
    left: -6px;
  }
  /deep/ .el-upload__tip {
    padding-top: 24px;
  }
  /deep/ .el-upload-list {
    display: none;
  }
  .upload {
    margin-bottom: 20px;
  }
  .show-info {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 24px;
    color: #000000;
    margin-bottom: 30px;
  }
  .tags {
    padding-top: 30px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 20px;
    color: #BCBCBC;
  }
  .btn {
    text-align: center;
    margin-top: 35px;
  }
  .clear {
    display: inline-block;
    padding-left: 10px;
    font-size: 10px;
    cursor: pointer;
    color: #909298;
  }
  /deep/ .el-button--primary {
    width: 130px;
    // height: 50px;
    // background: #1F71FF;
    // border-radius: 40px;
    // font-size: 20px;
    // font-family: Source Han Sans CN;
    // font-weight: 400;
    // color: #FFFFFF;
    text-align: center;
  }
}

/deep/ .el-dialog__header {
  border-bottom: 1px solid #D9D9D9;
}

.padding-top-20{
  padding-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/view/recruit/index.vue